import { PriceCheckOutlinedIcon, ViewListOutlinedIcon, QueryStatsOutlinedIcon } from "../../../constants/images";
import * as basicConstants from "../../../constants/basic";
import { today, todayDay, formatDate2 } from "../../../utils/date";
import { getSelectedOptionFieldsName } from "../../../i18n";

// reportType ["0", "1", "2", "3", "4"]
// 週報：0
// 月報：1
// 雙週報：2
// 自訂走期：3
// 過去30天：4

export const SEND_TIME_DATA = {
  reportType: ["0"],
  weekday: 0,
  monthday: 0,
  biWeekDay: 0,
  weektime: 8
}

export const EMAIL_REPORT_TYPE = [
  {
    id: 'weekly',
    name: '週報',
    value: "0",
    label: 'common.sendDate.weekly',
    selectId: 'weekday',
    menuData: 'weekday',
  },
  {
    id: 'bi-weekly',
    name: '雙週報',
    value: "2",
    label: 'common.sendDate.bi-weekly',
    selectId: 'biWeekDay',
    menuData: 'weekday',
  },
  {
    id: 'monthly',
    name: '月報',
    value: "1",
    label: 'common.sendDate.monthly',
    selectId: 'monthday',
    menuData: 'monthday',
  },
  {
    id: 'last30Days',
    name: '過去30天',
    value: "4",
    label: 'common.sendDate.last30Days',
    selectId: 'monthday',
    menuData: 'monthday',
  },
]

export const EMAIL_MEDIA_DATA = {
  FACEBOOK: {
    subject: "FB",
    modalTitle: "emailData.template.facebook.modalTitle",
    name: '設定轉換型客戶信件指標'
  },
  GOOGLE: {
    subject: "Google",
    modalTitle: "emailData.template.modal.title",
    name: '設定信件範本'
  },
  LINE: {
    subject: "LINE",
    modalTitle: "emailData.template.modal.title",
    name: '設定信件範本'
  },
}

export const EMAIL_TEMPLATE_DATA = [
  {
    id: 'facebook-reach-link-click',
    name: basicConstants.EMAIL_TEMPLATE_REACH,
    media: 'FACEBOOK',
    label: 'emailData.template.facebook.type.reachPointGoal',
    content: 'emailData.template.facebook.button.remainingBudget',
    modal: false,
    icon: <PriceCheckOutlinedIcon variant="lg_grey" sx={{ color: 'inherit' }} />
  },
  {
    id: 'facebook-conversion-1',
    name: basicConstants.EMAIL_TEMPLATE_COVERSION_CAMPAIGN,
    media: 'FACEBOOK',
    label: 'emailData.template.facebook.type.conversionKeyMetrics',
    content: 'emailData.template.facebook.button.keyMetrics',
    modal: true,
    icon: <ViewListOutlinedIcon variant="lg_grey" sx={{ color: 'inherit' }} />
  },
  {
    id: 'facebook-conversion-2',
    name: basicConstants.EMAIL_TEMPLATE_COVERSION_METRICS,
    media: 'FACEBOOK',
    label: 'emailData.template.facebook.type.conversionCampaign',
    content: 'emailData.template.facebook.button.campaign',
    modal: true,
    icon: <QueryStatsOutlinedIcon variant="lg_grey" sx={{ color: 'inherit' }} />
  },
  {
    id: 'line-conversion-1',
    name: basicConstants.EMAIL_TEMPLATE_COVERSION_CAMPAIGN,
    media: 'LINE',
    label: 'emailData.template.default',
    content: 'emailData.template.line.button.campaignCreative',
    modal: true,
    icon: <ViewListOutlinedIcon variant="lg_grey" sx={{ color: 'inherit' }} />
  },
  {
    id: 'google-conversion-1',
    name: basicConstants.EMAIL_TEMPLATE_COVERSION_CAMPAIGN,
    media: 'GOOGLE',
    label: 'emailData.template.default',
    content: 'emailData.template.google.button',
    modal: true,
    icon: <ViewListOutlinedIcon variant="lg_grey" sx={{ color: 'inherit' }} />
  },
];

export const EMAIL_FIELDS_BLOCKS = [
  {
    id: 'facebook-overviewFields',
    name: basicConstants.FIELDS_OVERVIEW,
    media: 'FACEBOOK',
    category: '',
    title: 'emailData.template.modal.overview',
    form: 'Autocomplete',
    option: false, // 選填
    content: 'emailData.template.modal.overviewLastWeek'
  },
  {
    id: 'facebook-creativeFields',
    name: basicConstants.FIELDS_CREATIVE,
    media: 'FACEBOOK',
    category: '',
    title: 'emailData.template.modal.creativePerformance',
    form: 'Autocomplete',
    option: true,
    content: ''
  },
  {
    id: 'facebook-taFields',
    name: basicConstants.FIELDS_TA,
    media: 'FACEBOOK',
    category: '',
    title: 'emailData.template.modal.audiencePerformance',
    form: 'Autocomplete',
    option: true,
    content: ''
  },
  {
    id: 'line-overviewFields',
    name: basicConstants.LINE_FIELDS_OVERVIEW,
    media: 'LINE',
    category: '',
    title: 'emailData.template.modal.overview',
    form: '',
    option: true,
    content: 'emailData.template.modal.overviewThisWeek'
  },
  {
    id: 'line-creativeFields',
    name: basicConstants.LINE_FIELDS_CREATIVE,
    media: 'LINE',
    category: '',
    title: 'emailData.template.modal.creativePerformance.optional',
    form: 'Autocomplete',
    option: true,
    content: 'emailData.template.line.tip.creativeFields'
  },
  {
    id: 'line-remainbudget',
    name: basicConstants.LINE_REMAINBUDGET,
    media: 'LINE',
    category: '',
    title: 'emailData.template.facebook.button.remainingBudget',
    form: 'Radio',
    option: true,
    content: ''
  },
  {
    id: 'google-overviewFields',
    name: basicConstants.FIELDS_OVERVIEW,
    media: 'GOOGLE',
    category: '',
    title: 'emailData.template.modal.overview',
    form: 'Autocomplete',
    option: true,
    content: 'emailData.template.modal.overviewThisWeek'
  },
  {
    id: 'google-overviewFields-search',
    name: basicConstants.SEARCH_OVERVIEW,
    media: 'GOOGLE',
    category: 'emailData.template.google.campaignType.search',
    title: 'emailData.template.modal.overview',
    form: 'Autocomplete',
    option: true,
    content: ''
  },
  {
    id: 'google-KeywordFields-search',
    name: basicConstants.SEARCH_KEYWORD,
    media: 'GOOGLE',
    category: 'emailData.template.google.campaignType.search',
    title: 'emailData.template.google.campaignType.keyword',
    form: 'Autocomplete',
    option: true,
    content: ''
  },
  {
    id: 'google-overviewFields-pmax',
    name: basicConstants.PERFORMANCE_MAX,
    media: 'GOOGLE',
    category: 'emailData.template.google.campaignType.pmax',
    title: 'emailData.template.modal.overview',
    form: 'Autocomplete',
    option: true,
    content: ''
  },
  {
    id: 'google-overviewFields-demand',
    name: basicConstants.DEMAND_GEN,
    media: 'GOOGLE',
    category: 'emailData.template.google.campaignType.demandGen',
    title: 'emailData.template.modal.overview',
    form: 'Autocomplete',
    option: true,
    content: ''
  },
  {
    id: 'google-overviewFields-video',
    name: basicConstants.VIDEO,
    media: 'GOOGLE',
    category: 'emailData.template.google.campaignType.video',
    title: 'emailData.template.modal.overview',
    form: 'Autocomplete',
    option: true,
    content: ''
  },
  {
    id: 'google-overviewFields-display',
    name: basicConstants.DISPLAY,
    media: 'GOOGLE',
    category: 'emailData.template.google.campaignType.display',
    title: 'emailData.template.modal.overview',
    form: 'Autocomplete',
    option: true,
    content: ''
  },
]

export const handleMailMessageExtra = (media, emailTemplateType, emailTemplateCurrent, reportLanguage, intl) => {
  let sendEmailTemplate = {};

  if (emailTemplateType === basicConstants.EMAIL_TEMPLATE_REACH) {
    sendEmailTemplate = null;
  } else {
    Object.keys(emailTemplateCurrent).forEach(el => {
      if (el !== 'type' && emailTemplateCurrent[el].length) {
        sendEmailTemplate[el] = emailTemplateCurrent[el].map(item => {
          return {
            name: getSelectedOptionFieldsName(media, item, reportLanguage),
            expression: item.expression,
            format: item.format,
            type: item.type,
          }
        })
      }
    })
  }

  return sendEmailTemplate;
}

// LINE remainbudget
export const handleEmailRemainbudget = (emailTemplateCurrent) => {
  if (!emailTemplateCurrent || (!emailTemplateCurrent.hasOwnProperty('taFields') && !emailTemplateCurrent.hasOwnProperty('remainbudget'))) {
    return null;
  }

  const { remainbudget, taFields, type } = emailTemplateCurrent;

  if (remainbudget === true) {
    return taFields && taFields.length > 0 ? { type, taFields } : null;
  }

  if (remainbudget === false) {
    return taFields && taFields.length !== 0 ? { remainbudget: false, type, taFields } : { remainbudget: false };
  }

  return emailTemplateCurrent;
}

export const getBiweeklyStart = (biWeekDay, time) => {
  const currentHours = today.getHours();

  // 距離下一個指定星期幾的天數
  const daysUntilNextbiWeekDay = (biWeekDay + 7 - todayDay) % 7;
  const nextbiWeekDay = new Date(today);

  // 設置 nextbiWeekDay 為距離今天最近的指定日期
  nextbiWeekDay.setDate(today.getDate() + daysUntilNextbiWeekDay);

  // 如果 biWeekDay 等於今天的星期，且當前時間晚於寄送時間，則14天後寄送(BiweeklyStart設為今天)
  if (biWeekDay === todayDay && currentHours >= time) {
    nextbiWeekDay.setDate(nextbiWeekDay.getDate());
  } else {
    // 否則向前推14天(當天就寄送)
    nextbiWeekDay.setDate(nextbiWeekDay.getDate() - 14);
  }

  const finalDate = formatDate2(nextbiWeekDay);
  return finalDate;
}

export const handleBiweeklyStart = (currentActiveData, sendTimeData) => {
  const currentBiweeklyStart = currentActiveData.biweekly_start;
  const currentBiweeklyDay = currentActiveData.biweekly_day;
  const currentSendTime = currentActiveData.sendTime;
  const isBiweeklyDayChange = currentBiweeklyDay === sendTimeData.biWeekDay + 1 ? false : true;
  const isSendTimeChange = currentSendTime === basicConstants.HOUR_LIST[sendTimeData.weektime] ? false : true;

  // 設定過雙週報且未更改設定，取原設定日期
  if (currentBiweeklyStart !== null && !isBiweeklyDayChange && !isSendTimeChange) {
    const year = currentBiweeklyStart.year;
    const month = String(currentBiweeklyStart.monthValue).padStart(2, '0');
    const day = String(currentBiweeklyStart.dayOfMonth).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  // 沒設定過雙週報或有更改設定，重新設定日期
  return getBiweeklyStart(sendTimeData.biWeekDay + 1, sendTimeData.weektime);
}
